@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.user_status_pending: StringResource by lazy {
      StringResource("string:user_status_pending", "user_status_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31088, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27168, 55),
      ))
    }

public val Res.string.users: StringResource by lazy {
      StringResource("string:users", "users", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31180, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27252, 21),
      ))
    }

public val Res.string.users_title: StringResource by lazy {
      StringResource("string:users_title", "users_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31148, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27224, 27),
      ))
    }

public val Res.string.was_damage_caused: StringResource by lazy {
      StringResource("string:was_damage_caused", "was_damage_caused", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31231, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27295, 77),
      ))
    }

public val Res.string.wednesday: StringResource by lazy {
      StringResource("string:wednesday", "wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31317, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27373, 29),
      ))
    }

public val Res.string.week: StringResource by lazy {
      StringResource("string:week", "week", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31347, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27403, 20),
      ))
    }

public val Res.string.welcome: StringResource by lazy {
      StringResource("string:welcome", "welcome", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31417, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27465, 39),
      ))
    }

public val Res.string.welcome_back: StringResource by lazy {
      StringResource("string:welcome_back", "welcome_back", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31368, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27424, 40),
      ))
    }

public val Res.string.were_safety_met: StringResource by lazy {
      StringResource("string:were_safety_met", "were_safety_met", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31465, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27505, 83),
      ))
    }

public val Res.string.what_happens: StringResource by lazy {
      StringResource("string:what_happens", "what_happens", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31581, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27589, 60),
      ))
    }

public val Res.string.whether: StringResource by lazy {
      StringResource("string:whether", "whether", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31646, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27650, 195),
      ))
    }

public val Res.string.work_schedule: StringResource by lazy {
      StringResource("string:work_schedule", "work_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31854, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27846, 41),
      ))
    }

public val Res.string.working_hours: StringResource by lazy {
      StringResource("string:working_hours", "working_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31892, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27888, 41),
      ))
    }

public val Res.string.workspace_name: StringResource by lazy {
      StringResource("string:workspace_name", "workspace_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31934, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27930, 42),
      ))
    }

public val Res.string.workspace_not_found: StringResource by lazy {
      StringResource("string:workspace_not_found", "workspace_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 31985, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27973, 55),
      ))
    }

public val Res.string.workspace_settings: StringResource by lazy {
      StringResource("string:workspace_settings", "workspace_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32053, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28029, 50),
      ))
    }

public val Res.string.workspace_type: StringResource by lazy {
      StringResource("string:workspace_type", "workspace_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32120, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28080, 42),
      ))
    }

public val Res.string.yearly: StringResource by lazy {
      StringResource("string:yearly", "yearly", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32167, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28123, 30),
      ))
    }

public val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32202, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28154, 15),
      ))
    }

public val Res.string.you_are_offline: StringResource by lazy {
      StringResource("string:you_are_offline", "you_are_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32218, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28170, 175),
      ))
    }

public val Res.string.you_are_subscribed: StringResource by lazy {
      StringResource("string:you_are_subscribed", "you_are_subscribed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32434, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28346, 90),
      ))
    }

public val Res.string.you_chose: StringResource by lazy {
      StringResource("string:you_chose", "you_chose", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32541, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28437, 29),
      ))
    }

public val Res.string.you_will_lose: StringResource by lazy {
      StringResource("string:you_will_lose", "you_will_lose", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32583, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28467, 133),
      ))
    }

public val Res.string.your_comment: StringResource by lazy {
      StringResource("string:your_comment", "your_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32729, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28601, 36),
      ))
    }

public val Res.string.your_data_will: StringResource by lazy {
      StringResource("string:your_data_will", "your_data_will", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32770, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28638, 106),
      ))
    }

public val Res.string.your_email_address: StringResource by lazy {
      StringResource("string:your_email_address", "your_email_address", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32893, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28745, 50),
      ))
    }

public val Res.string.your_full_name: StringResource by lazy {
      StringResource("string:your_full_name", "your_full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 32948, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28796, 42),
      ))
    }

public val Res.string.your_password: StringResource by lazy {
      StringResource("string:your_password", "your_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33003, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28839, 41),
      ))
    }

public val Res.string.zip: StringResource by lazy {
      StringResource("string:zip", "zip", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33131, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28955, 15),
      ))
    }

public val Res.string.zip_employee: StringResource by lazy {
      StringResource("string:zip_employee", "zip_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33045, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28881, 24),
      ))
    }

public val Res.string.zip_required: StringResource by lazy {
      StringResource("string:zip_required", "zip_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 33070, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28906, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("user_status_pending", Res.string.user_status_pending)
  map.put("users", Res.string.users)
  map.put("users_title", Res.string.users_title)
  map.put("was_damage_caused", Res.string.was_damage_caused)
  map.put("wednesday", Res.string.wednesday)
  map.put("week", Res.string.week)
  map.put("welcome", Res.string.welcome)
  map.put("welcome_back", Res.string.welcome_back)
  map.put("were_safety_met", Res.string.were_safety_met)
  map.put("what_happens", Res.string.what_happens)
  map.put("whether", Res.string.whether)
  map.put("work_schedule", Res.string.work_schedule)
  map.put("working_hours", Res.string.working_hours)
  map.put("workspace_name", Res.string.workspace_name)
  map.put("workspace_not_found", Res.string.workspace_not_found)
  map.put("workspace_settings", Res.string.workspace_settings)
  map.put("workspace_type", Res.string.workspace_type)
  map.put("yearly", Res.string.yearly)
  map.put("yes", Res.string.yes)
  map.put("you_are_offline", Res.string.you_are_offline)
  map.put("you_are_subscribed", Res.string.you_are_subscribed)
  map.put("you_chose", Res.string.you_chose)
  map.put("you_will_lose", Res.string.you_will_lose)
  map.put("your_comment", Res.string.your_comment)
  map.put("your_data_will", Res.string.your_data_will)
  map.put("your_email_address", Res.string.your_email_address)
  map.put("your_full_name", Res.string.your_full_name)
  map.put("your_password", Res.string.your_password)
  map.put("zip", Res.string.zip)
  map.put("zip_employee", Res.string.zip_employee)
  map.put("zip_required", Res.string.zip_required)
}
